import { createContext, RefObject, useContext } from "react";
import { Page } from "../types";

export const NavigationContext = createContext<{
  navigate: (page: Page) => void;
  page: Page;
  prevPageRef?: RefObject<Page>;
}>({
  navigate: () => {},
  page: Page.Start,
});

export const useNavigate = () => useContext(NavigationContext);
